// Resolves the actual parent (dashboard) origin embedding this iframe.
// Hard-coding REACT_APP_DASHBOARD_URL drops every postMessage (and breaks the
// initial JWT handshake) when the parent isn't that single value — e.g. the
// employee dev console (dev.console.unitag.io) or white-label parents
// (asteria.console.sandbox.unitag.io). Same pattern as gs1-frontend's
// src/utils/parentOrigin.ts.

const PARENT_ORIGIN_PATTERN = /^https:\/\/([a-z0-9-]+\.)?console(\.sandbox)?\.unitag\.io$/

const fallback = (): string => `${process.env.REACT_APP_DASHBOARD_URL ?? ""}`

function deriveParentOrigin(): string {
    try {
        const ref = document.referrer
        if (ref) {
            const o = new URL(ref).origin
            if (PARENT_ORIGIN_PATTERN.test(o) || o === fallback()) return o
        }
    } catch {
        // intentional fall through
    }
    return fallback()
}

export const parentOrigin = deriveParentOrigin()

export const isAllowedParentOrigin = (o: string): boolean =>
    o === parentOrigin || PARENT_ORIGIN_PATTERN.test(o) || o === fallback()
